export enum PmInvalidFieldEnum {
  PROSECUTOR_ORGANIZATION_ERKNM = 'prosecutorOrganization',
  PM_REASONS_ERKNM_ERVK_UUID = 'pmErknm.reasons[{id}].reason',
  PM_REASONS_ERKNM_ORDER = 'pmErknm.reasons[{id}].order',
  PM_REASONS_ERKNM_RISK_INDICATORS = 'pmErknm.reasons[{id}].riskIndicators',
  PM_REASONS_ERKNM_RISK_INDICATOR = 'pmErknm.reasons[{id}].riskIndicators[{id}].riskIndicator',
  PM_SUPERVISION_TYPE = 'pmErknm.supervisionType',
  PM_KNO_ORGANIZATION = 'pmErknm.knoOrganization',
  PM_TYPE = 'pmErknm.pmType',
  PM_EVENTS_ERKNM_TYPE = 'pmErknm.eventsPm[{id}].event',
  PM_REQUIREMENTS_NPA_ID = 'pmErknm.requirements[{id}]',
  PM_REQUIREMENTS_NPA_STRUCTURAL_UNIT_ID = 'pmErknm.requirements[{id}].structuralUnit',
  PM_ORGANIZATIONS_SUBJECT_TYPE = 'pmErknm.subject.subjectType',
}
